import {useState} from 'react';
import {I18n} from '@aws-amplify/core';
import {AiOutlineFilter} from 'react-icons/ai';
import {Indicator} from '@mantine/core';
import {FlexiButton} from '@flexinet/ui-components';
import {FilterDrawer} from '../drawers/FilterDrawer';
import {useUsersFilter} from '../hooks/useUsersFilter';

export const FilterRecordButton = () => {
    const [opened, setOpened] = useState(false);
    const {activeCount} = useUsersFilter();

    return (
        <>
            {/* The active-filter count, from the theme rather than fixed colours and pixels. */}
            <Indicator label={activeCount} size={'md'} disabled={activeCount === 0}>
                <FlexiButton leftSection={<AiOutlineFilter/>} aria-label={I18n.get('Filter')}
                             onClick={() => setOpened(true)}>
                    {I18n.get('Filter')}
                </FlexiButton>
            </Indicator>
            <FilterDrawer opened={opened} onClose={() => setOpened(false)}/>
        </>
    );
};
